// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-auv-js": () => import("./../../../src/pages/auv.js" /* webpackChunkName: "component---src-pages-auv-js" */),
  "component---src-pages-gtocx-js": () => import("./../../../src/pages/gtocx.js" /* webpackChunkName: "component---src-pages-gtocx-js" */),
  "component---src-pages-ibike-js": () => import("./../../../src/pages/ibike.js" /* webpackChunkName: "component---src-pages-ibike-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-siemens-js": () => import("./../../../src/pages/siemens.js" /* webpackChunkName: "component---src-pages-siemens-js" */),
  "component---src-pages-teamindus-js": () => import("./../../../src/pages/teamindus.js" /* webpackChunkName: "component---src-pages-teamindus-js" */)
}

